/**
 * Canonical path roots for donation flows.
 * Keep next.config.js redirects in sync with these values.
 */

export const DONATION_PATH_SEGMENT = 'sostienici'
export const DONATION_PATH_ROOT = `/${DONATION_PATH_SEGMENT}`

export const LND_PATH_SEGMENT = 'lnd'
export const LND_PATH_ROOT = `/${LND_PATH_SEGMENT}`

/** Legacy URL segment — redirects only; still allowed in CMS CTA sanitize. */
export const LEGACY_DONATION_PATH_SEGMENT = 'dona'
export const LEGACY_DONATION_PATH_ROOT = `/${LEGACY_DONATION_PATH_SEGMENT}`

/**
 * Join segments under the donation root.
 * @param {...string} segments e.g. 'confirm', 'natale-2026', 'successo'
 * @returns {string} e.g. '/sostienici/confirm'
 */
export function donationPath(...segments) {
  const cleaned = segments
    .filter((s) => s !== undefined && s !== null && String(s).length > 0)
    .map((s) => String(s).replace(/^\/+|\/+$/g, ''))
  return cleaned.length
    ? `${DONATION_PATH_ROOT}/${cleaned.join('/')}`
    : DONATION_PATH_ROOT
}

export default {
  DONATION_PATH_SEGMENT,
  DONATION_PATH_ROOT,
  LND_PATH_SEGMENT,
  LND_PATH_ROOT,
  LEGACY_DONATION_PATH_SEGMENT,
  LEGACY_DONATION_PATH_ROOT,
  donationPath,
}
